export enum BLIND_ACTIONS {
    COMPLETE = 'COMPLETE',
    PARTIAL = 'PARTIAL',
    BLADES = 'BLADES'
}


// WEBPACK FOOTER //
// ./src/components/node-actuator/actuator-blind/actuator-blind.enum.ts